import { render } from "./DocumentsModal.vue?vue&type=template&id=47df6ee9&scoped=true"
import script from "./DocumentsModal.vue?vue&type=script&lang=js"
export * from "./DocumentsModal.vue?vue&type=script&lang=js"

import "./DocumentsModal.vue?vue&type=style&index=0&id=47df6ee9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47df6ee9"]])

export default __exports__